// extracted by mini-css-extract-plugin
module.exports = {"container":"Parent_container__3WZ5r","headline":"Parent_headline__2QJpc"};